// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import ActivitiesView from "../../components/rgsICU/activities";

const Activities = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <ActivitiesView />
    </Main>
  </>
);

export default Activities;
